import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Input } from '../../..'

import styles from './YearsInput.module.scss'

const YearsInput = ({ className, ...restProps }) => (
  <Input
    className={classnames(className, styles.yearsInput)}
    type='number'
    appendText='years'
    {...restProps}
  />
)

YearsInput.propTypes = {
  className: PropTypes.string,
}

export default YearsInput
